import * as types from "../../constants";

const initialState = {
    loading: false,
    pendingActions : []
}

export default function reducer(state = initialState, action){
    
    let newState = { ...state};
    let tempPendingActions;
    switch(action.type){
        case types.UPDATE_RECORDS_LOADING:
            // SHER-233: bail out with the same reference on a true no-op
            // (nothing observable would change) instead of always spreading
            // a new `state.offline` object. Dashboard.jsx dispatches this
            // action from a service-worker message listener repeatedly while
            // idle, and every unconditional new reference was re-rendering
            // components subscribed to state.offline for no reason.
            if(state.loading === action.loading && (action.loading || state.pendingActions.length === 0)){
                return state;
            }
            newState.loading = action.loading;
            if(!action.loading){
                newState.pendingActions = [];
            }
            return newState;
        case types.UPDATE_PATIENT_OFFLINE:
        case types.SAVE_PATIENT_OFFLINE:
            tempPendingActions = [...newState.pendingActions];
            tempPendingActions.push({action : "patient"});
            newState.pendingActions = tempPendingActions;

            return newState;
        case types.SAVE_SUBMISSIONS_PATIENT_OFFLINE:
            tempPendingActions = [...newState.pendingActions];
            tempPendingActions.push({action : "submission"});
            newState.pendingActions = tempPendingActions;
            return newState;
        case types.RESET_OFFLINE_NOTIFICATIONS:
            return initialState;
        default:
            return state;    
    }

     
}